import { LoadActions } from '@app/core/store/_prototypes/action-reducers/actions/load.actions';
import {
  initializeLoadStateWithoutData,
  LoadState,
} from '@app/core/store/_prototypes/action-reducers/state/load.state';
import { ActionCreator, ActionReducer, ReducerTypes, createReducer, on } from '@ngrx/store';

export const createLoadReducer = <Key extends object, State extends LoadState<Key, T>, T>(
  initialState: State,
  actions: LoadActions<Key, T>,
  customOns: ReducerTypes<State, ActionCreator[]>[] = []
) => createReducer(initialState, ...loadOns(actions, initialState), ...customOns) as ActionReducer<State, any>;

export const loadOns = <Key extends object, State extends LoadState<Key, T>, T>(
  actions: LoadActions<Key, T>,
  initialState: State
) => [
  // Execute
  on(actions.load.execute, (state: State, action) => ({
    ...state,
    ...initializeLoadStateWithoutData<Key, T>(),
    loading: true,
    busy: true,
    requested: action.request,
  })),

  // Completed
  on(actions.load.completed, (state: State) => ({
    ...state,
    ...initializeLoadStateWithoutData<Key, T>(),
    requested: state.requested,
  })),

  // Success
  on(actions.load.success, (state: State, action) => ({
    ...state,
    ...initializeLoadStateWithoutData<Key, T>(),
    requested: state.requested,
    success: true,
    data: action.data,
    loaded: action.loaded,
  })),

  // Failure
  on(actions.load.failure, (state: State, action) => ({
    ...state,
    ...initialState,
    requested: state.requested,
    failed: action.error,
  })),
];
